<template>
    <div>
        <b-form-group
                label="Fields"
                label-for="fields"
                :label-cols="3"
                :horizontal="false">
            <b-button variant="primary" @click="showEditor = true">{{ $t('openEditor') }}</b-button>
        </b-form-group>
        <main-dialog v-model="showEditor" :title="$t('fields')" hide-footer size="lg">
            <Fields v-model="fieldset" :config="{
                custom:component.general.is_custom,dependencyProtected:!canRemove,
                disableSchemas:true
                }" :component="component"
            />
        </main-dialog>
    </div>
</template>
<script>
export default {
    components: {
        Fields: () => import("../../../base/Settings/FieldsV2")
    },
    props: {
        value: {
            type: Object,
            default: function() {
                return null
            }
        },

        component: {
            type: Object,
        }
    },
    data: function() {
        return {
            showEditor: false
        }
    },
    computed: {
        constraints: {
            get() {
                let base = this.value
                let {custom_data = {}} = base
                let {fieldset} = custom_data

                if (!fieldset) {
                    custom_data.fieldset = []
                }

                return base;
            },

            set(val) {
                this.$emit('input', val)
            }
        },

        fieldset: {
            get() {
                return this.constraints.custom_data.fieldset
            },

            set(val) {
                this.constraints = {
                    ...this.constraints,
                    custom_data: {
                        ...this.constraints.custom_data,
                        fieldset: val
                    }
                }
            }
        },

        canRemove() {
            if (this.component.general.dependencies === null) return true
            
            return this.component.general.dependencies.length == 1 && this.component.general.dependencies[0] == "platform"
        },
    },
    methods: {
        
    }
    
}
</script>